import React from 'react';
import { motion } from 'framer-motion';

const Founders = () => {
  // Placeholder image URL - Replace with your actual founder images
  // const founderImg = "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400";

   const founderImg=[
    {
      img:"/assets/images/img22.webp",
      name:"Anshul Gupta",
      desination:"CEO"
    },
    {
      img:"/assets/images/img23.webp",
      name:"Ramandeep Singh",
      desination:"CMO"
    },
    {
      img:"/assets/images/vikrant.webp",
       name:"Vikrant Sharma",
      desination:"CTO"
    }
    
   ]
  // Animation Variants for reusability
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        ease: "easeOut",
      },
    }),
  };

  return (
    <div className="ax-founders-sec-container">

      {/* Top Header */}
      <motion.div 
        className="ax-founders-header"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8 }}
      >
        <div className="ax-founders-title">
          <span className="ax-founders-our">Our</span>{" "}
          <span className="ax-founders-main">  FOUNDERS</span>
          <motion.div 
            className="ax-founders-underline"
            initial={{ width: 0 }}
            whileInView={{ width: "100%" }}
            viewport={{ once: false }}
            transition={{ duration: 1, delay: 0.5 }}
          ></motion.div>
        </div>
      </motion.div>

      {/* Arc Graphic and Middle Text */}
      <div className="ax-arc-wrapper">
        <svg className="ax-arc-svg" viewBox="0 0 800 200" fill="none">
          <motion.path 
            initial={{ pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
            d="M50 200 C 50 50, 750 50, 750 200" stroke="white" strokeWidth="1" fill="none" 
          />
          <motion.path 
            initial={{ pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 1.5, delay: 0.2, ease: "easeInOut" }}
            d="M100 200 C 100 80, 700 80, 700 200" stroke="white" strokeWidth="1" fill="none" 
          />
          <motion.path 
            initial={{ pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 1.5, delay: 0.4, ease: "easeInOut" }}
            d="M150 200 C 150 110, 650 110, 650 200" stroke="white" strokeWidth="1" fill="none" 
          />
        </svg>
        <motion.div 
          className="ax-arc-text"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          The Brains Behind <br /> the Brand
        </motion.div>
      </div>

      {/* Team Cards */}
      <div className="ax-founders-grid">
        {founderImg.map((item,index) => (
          <motion.div 
            key={index}
            className="ax-founder-card"
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false }}
            variants={cardVariants}
            whileHover={{ y: -10, transition: { duration: 0.3 } }}
          >
            <div   className='custom-ab-founder'>
                  <img src={item.img} alt={`Founder ${index + 1}`} className="ax-founder-image"   loading="lazy"/>
            </div>
           
              
              <p  className='mt-3 mb-0   custom-name-founder-axe'    >{item.name}</p>
               <p  className='custom-fonder-desination'>{item. desination}</p>
          </motion.div>
          
        ))}
      </div>
    </div>
  );
};

export default Founders;
